
export const
    navitem = [
        {
            id: 1,
            url: '/',
            text: 'Home',
            //   icon: <FaHome />,
        },
        // {
        //     id: 2,
        //     url: '/Profile',
        //     text: 'Profile',
        //     //   icon: <FaHome />,
        // },
        {
            id: 3,
            url: '/FavoriteCart',
            text: <i className="bi bi-balloon-heart-fill text-red-600 text-2xl"></i>
            //   icon: <FaUserFriends />,
        },
        // {
        //     id: 3,
        //     url: '/',
        //     text: <i className="bi bi-file-person-fill"></i>,
        //     //   icon: <FaFolderOpen />,
        // },
        {
            id: 4,
            url: '/SendUsMessage',
            text: 'Contact Us',
            //   icon: <FaFolderOpen />,
        },
    ];
